{
  "PRIVATE_PREFIX": "_",
  "DEPTH_LIMIT": 10,
  "MAX_COST": 1000,
  "CRUNCH": {
    "USE": true,
    "VERSION": 2
  }
}
